var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"icon":""}},[_vm._v("fab fa-whatsapp")])],1)]}}])},[_c('v-card',[_c('v-card-title',[_vm._v("whatsapp")]),_c('v-card-text',[_vm._v(_vm._s(_vm.proveedores)+" "+_vm._s(_vm.id))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }